export const travelTypeEnum = {
    private: 'פרטית',
    sadir: 'סדירה' , 
    train : 'רכבת',
    regularSadir: 'סדירה ר' // סדירה רגיל
}

export const travelTypeAdminEnum = {
    private: 'private',
    sadir: 'sadir'
}

export const sideEnum = {
    toUman: 'לאומן',
    fromUman: 'מאומן'
}
